<template>
  <footer class="bottom-nav">
    <template v-for="item in navItems" :key="item.key">
      <a v-if="item.key !== 'publish'" :href="item.to" class="nav-item" :class="{ active: active === item.key }">
        <span class="nav-icon">{{ item.icon }}</span>
        <span v-if="item.label">{{ item.label }}</span>
      </a>
      <button v-else type="button" class="nav-item publish" @click="openPublish">
        <span class="nav-icon">{{ item.icon }}</span>
      </button>
    </template>
  </footer>

  <div v-if="showPublish" class="publish-mask" @click.self="closePublish">
    <div class="publish-dialog">
      <div class="publish-title">分享新资源</div>
      <div class="publish-grid">
        <textarea v-model="content" class="publish-input" rows="4" placeholder="直接把网盘分享的口令填在这里即可,系统会自动分类处理"></textarea>
        <!-- <button v-for="option in publishOptions" :key="option.key" class="publish-option"
          @click="selectOption(option.key)">
          <div class="option-icon">{{ option.icon }}</div>
          <div class="option-label">{{ option.label }}</div>
        </button> -->
      </div>
      <div class="publish-actions">
        <button class="close-btn" type="button" @click="closePublish">
          取消
        </button>
        <button class="publish-btn" type="button" @click="save">
          分享
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Upload, message } from "ant-design-vue";
const props = defineProps<{
  active?: "home" | "follow" | "publish" | "member" | "me";
}>();

const navItems = [
  { key: "home", label: "首页", icon: "🏠", to: "/" },
  { key: "follow", label: "邀请他人", icon: "👁️", to: "/users/myinviter" },
  { key: "publish", label: "", icon: "＋", to: "/publish" },
  { key: "member", label: "我的分享", icon: "🎟️", to: "/users/myshare" },
  { key: "me", label: "我的", icon: "😊", to: "/users/center" },
];

const active = props.active ?? "home";
const showPublish = ref(false);
const content = ref("");


const openPublish = () => {
  showPublish.value = true;
};
const closePublish = () => {
  showPublish.value = false;
};
const save = async () => {
  let arg = {
    content: content.value
  }
  const data = await $api_Source_AddSource({
    method: "POST",
    body: arg,
    server: false,
  });
  const curData = data as IApiResponse<any>;
  if (curData?.code === 1) {
    message.success("分享成功，等待后台审核");
    closePublish()
  } else {
    console.log('分享失败', curData)
    message.error(curData?.message);
  }
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  background: #ffffff;
  border-top: 1px solid #e6e8ec;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
  z-index: 12;
}

.nav-item {
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-size: 12px;
  color: #666;
  text-decoration: none;
}

.nav-item.active {
  color: #fb7299;
}

.nav-item.publish {
  background: #fb7299;
  color: #fff;
  border-radius: 16px;
  margin: 8px;
  font-weight: 700;
  cursor: pointer;
}

.nav-icon {
  font-size: 16px;
}

.publish-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: grid;
  place-items: center;
  z-index: 20;
}

.publish-dialog {
  background: #fff;
  width: 92%;
  max-width: 420px;
  border-radius: 16px;
  padding: 18px 16px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
}

.publish-title {
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 12px;
}

.publish-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.publish-input {
  border: 1px solid #f5e0e7;
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  font-size: 14px;
  color: #1f1f1f;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  resize: none;
}

.publish-input:focus {
  border-color: #fb7299;
  box-shadow: 0 8px 18px rgba(251, 114, 153, 0.15);
}

.publish-option {
  border: 1px solid #f5e0e7;
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #1f1f1f;
  transition: all 0.15s ease;
  width: 100%;
}

.publish-option:hover {
  border-color: #fb7299;
  box-shadow: 0 8px 18px rgba(251, 114, 153, 0.15);
}

.option-icon {
  font-size: 22px;
  width: 28px;
  text-align: center;
}

.option-label {
  font-size: 15px;
  font-weight: 700;
}

.close-btn {
  width: 100%;
  border: none;
  background: #e6e8ec;
  color: #666;
  padding: 10px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

.publish-actions {
  margin-top: 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.publish-btn {
  width: 100%;
  border: none;
  background: #fb7299;

  color: #fff;
  padding: 10px;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}
</style>
